import React, { useState, useEffect, useRef } from 'react';
import '../../../styles/homepagecss/GenBI.css';

const HomeGenBI = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [showDashboard, setShowDashboard] = useState(false);
  const [agentsVisible, setAgentsVisible] = useState([]);
  const sectionRef = useRef(null);

  // Agent structure with Bootstrap icons
  const agents = [
    { id: 1, name: 'Disease Definition Agent', icon: 'bi-heart-pulse-fill', delay: 0 },
    { id: 2, name: 'Efficacy Meta-Analyst Agent', icon: 'bi-graph-up-arrow', delay: 800 },
    { id: 3, name: 'Safety Profile Agent', icon: 'bi-shield-fill-check', delay: 1600 },
    { id: 4, name: 'Cost-Effectiveness Agent', icon: 'bi-currency-dollar', delay: 2400 },
  ];

  // Feature pills data structure
const featurePills = [
  {
    id: 1,
    title: 'Template Editor. Built for Your Team.',
    description: 'Intuitive interface with real-time collaboration for your team.'
  },
  {
    id: 2,
    title: 'Multimodal Intelligence.',
    description: 'Rich text, visualizations, tables, and references—all in one execution.'
  },
  {
    id: 3,
    title: 'Agent Version Control.',
    description: 'Restore previous versions instantly. Like undo, but for intelligence.'
  },
  {
    id: 4,
    title: 'Versioned Sourced Reports.',
    description: 'Complete reports with every insight sourced and claim referenced.'
  }
];

  // Intersection Observer
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setIsVisible(true);
          }
        });
      },
      { threshold: 0.3 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  // Animate agents appearing one by one
  useEffect(() => {
    if (!isVisible) return;

    agents.forEach((agent) => {
      setTimeout(() => {
        setAgentsVisible(prev => [...prev, agent.id]);
      }, agent.delay);
    });

    // Show dashboard after all agents appear
    setTimeout(() => {
      setShowDashboard(true);
    }, 3200);
  }, [isVisible]);

  return (
    <section className="background-color2 py-2" ref={sectionRef}>
      <div className="container">
        <div className="">
          <p className="ev-reg-p-dark ev-fs-20 ev-bold-med mb-1">GenBI Studio.</p>
          <p className="gradient-font7 ev-fs-20 margin-bottom-1 ev-bold-med">
      Design Once, and Agentic AI Handles the Rest, from Insights to Reports.
          </p>
        </div>

        {/* Feature Pills - Dynamic */}
        <div className="row margin-bottom-2">
          {featurePills.map((feature) => (
            <div key={feature.id} className="col-lg-3 col-md-3 col-6 d-flex g-3">
              <div class="ev-card-2 w-100 ev-padding-reg">
                <p className="ev-fs-14 ev-reg-p-dark ev-bold-med mb-1">{feature.title}</p>
                <p className="ev-fs-12 ev-reg-p-dark ev-reg">{feature.description}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Main Content: Agents + Dashboard */}
        <div className="row g-3">
          {/* RIGHT: Dashboard with 4 Graphs */}
          <div className="col-lg-7 col-md-7 ev-card-7 shadow-none ev-radius-med">
            <div className="ev-card-3 w-100 ev-padding-med margin-bottom-2">
                <div className="margin-bottom-2">
                  <p className="ev-small-p-blue ev-fs-15 ev-bold-med mb-1">Your AI Workforce</p>
                </div>

                {/* Animated Agents */}
                <div className="row g-2">
                  {agents.map((agent) => (
                    <div className="col-3 d-flex">
                      <div
                        key={agent.id}
                        className={`agent-execution-item ${agentsVisible.includes(agent.id) ? 'show' : ''}`}
                      >
                        <div className="agent-icon-wrapper">
                          <i className={`bi ${agent.icon} agent-icon`}></i>
                        </div>
                        <div className="agent-details">
                          <p className="ev-small-p-dark ev-fs-11 ev-bold-reg mb-0">{agent.name}</p>
                          <p className="ev-fs-11 ev-bold-reg gradient-font6 mb-0">
                            {agentsVisible.includes(agent.id) ? (
                              <>
                                <i className="bi bi-check-circle-fill"></i> Completed
                              </>
                            ) : (
                              <>
                                <i className="bi bi-clock"></i> Pending
                              </>
                            )}
                          </p>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>

                {/* Progress Summary */}
                {agentsVisible.length > 0 && (
                  <div className="execution-summary row">
                    <div className="summary-stat col-4">
                      <span className="stat-value gradient-font6">{agentsVisible.length}</span>
                      <span className="stat-label ev-fs-10 w-80  ev-message-card3 ev-radius-large">Completed Agents</span>
                    </div>
                    <div className="summary-stat col-4">
                      <span className="stat-value gradient-font6">{agents.length - agentsVisible.length}</span>
                      <span className="stat-label ev-fs-10 w-80  ev-message-card3 ev-radius-large">Pending Agents</span>
                    </div>
                    <div className="summary-stat col-4">
                      <span className="stat-value gradient-font6">{agents.length}</span>
                      <span className="stat-label ev-fs-10 w-80 ev-message-card3 ev-radius-large">Total Agents</span>
                    </div>
                  </div>
                )}
            </div>
            <div className={`ev-card-9 w-100 ev-padding-med genbi-dashboard-visualization ${showDashboard ? 'show' : ''}`}>
              <div className="mb-1">
                <div class="row">
                  <div className="col-7">
                    <p className="ev-small-p-blue ev-fs-15 ev-bold-med">Smart templates. Smarter agents. Brilliant reports.</p>
                  </div>
                  <div className="col-5">
                    {/* Generate Report Button */}
                    {showDashboard && (
                      <div className="text-end">
                        <div className="ev-message-card3">
                          <i className="bi bi-file-earmark-arrow-down-fill"></i> Generate Report
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>

              {/* First Row: 2 graphs (col-6, col-6) */}
              <div className="row mb-3">
                <div className="col-6">
                  <div className="graph-card">
                    <div className="graph-header">
                      <p className="ev-reg-p-dark ev-bold-reg mb-0">HbA1c Reduction</p>
                    </div>
                    <div className="graph-visual bar-chart">
                      <div className="bar-item vh-10" style={{ background: 'var(--color12)'}}></div>
                      <div className="bar-item vh-5" style={{background: 'var(--color1)'}}></div>
                      <div className="bar-item vh-8" style={{ background: 'var(--color14)'}}></div>
                      <div className="bar-item vh-3" style={{ background: 'var(--color9)'}}></div>
                      <div className="bar-item vh-5" style={{background: 'var(--color12)'}}></div>
                      <div className="bar-item vh-10" style={{ background: 'var(--color12)'}}></div>
                      <div className="bar-item vh-3" style={{ background: 'var(--color14)'}}></div>
                      <div className="bar-item vh-8" style={{ background: 'var(--color9)'}}></div>
                      <div className="bar-item vh-3" style={{ background: 'var(--color10)'}}></div>
                      <div className="bar-item vh-5" style={{background: 'var(--color9)'}}></div>
                      <div className="bar-item vh-10" style={{ background: 'var(--color9)'}}></div>
                      <div className="bar-item vh-5" style={{ background: 'var(--color10)'}}></div>
                      <div className="bar-item vh-8" style={{ background: 'var(--color9)'}}></div>
                      <div className="bar-item vh-5" style={{ background: 'var(--color9)'}}></div>
                      <div className="bar-item vh-8" style={{background: 'var(--color14)'}}></div>
                      
                    </div>
                    <div className="graph-footer">
                      <span className="ev-fs-11 ev-reg-p-blue">Meta-analysis results</span>
                    </div>
                  </div>
                </div>
                <div className="col-6">
                  <div className="graph-card">
                    <div className="graph-header">
                      <p className="ev-reg-p-dark ev-bold-reg mb-0">Adverse Events</p>
                    </div>
                    <div className="graph-visual pie-chart">
                      <svg viewBox="0 0 100 100" className="pie-svg">
                        <circle cx="50" cy="50" r="40" fill="none" stroke="var(--color9)" strokeWidth="20" strokeDasharray="75 25" strokeDashoffset="25"></circle>
                        <circle cx="50" cy="50" r="40" fill="none" stroke="var(--color14)" strokeWidth="20" strokeDasharray="25 75" strokeDashoffset="-50"></circle>
                      </svg>
                      <div className="pie-center">
                        <span className="ev-fs-15 ev-bold-med gradient-font5">66%</span>
                      </div>
                    </div>
                    <div className="graph-footer">
                      <span className="ev-fs-11 ev-reg-p-blue">Safety profile</span>
                    </div>
                  </div>
                </div>
              </div>

              {/* Second Row: 2 graphs (col-7, col-5) */}
              <div className="row">
                <div className="col-7">
                  <div className="graph-card">
                    <div className="graph-header">
                      <p className="ev-reg-p-dark ev-bold-reg mb-0">Treatment Persistence</p>
                    </div>
                    <div className="graph-visual line-chart w-90 m-auto">
                      <svg viewBox="0 0 200 80" className="line-svg">
                        <polyline
                          points="10,70 50,50 90,40 130,35 170,30"
                          fill="none"
                          stroke="var(--color9)"
                          strokeWidth="2"
                        />
                        <polyline
                          points="10,70 50,60 90,55 130,52 170,50"
                          fill="none"
                          stroke="var(--color14)"
                          strokeWidth="2"
                          strokeDasharray="5,5"
                        />
                      </svg>
                    </div>
                    <div className="graph-footer">
                      <span className="ev-fs-11 ev-reg-p-blue">12-month RWE data</span>
                    </div>
                  </div>
                </div>
                <div className="col-5">
                  <div className="graph-card">
                    <div className="graph-header">
                      <p className="ev-reg-p-dark ev-bold-reg mb-0">ICER Analysis</p>
                    </div>
                    <div className="graph-visual scatter-chart">
                      <div className="scatter-point" style={{left: '30%', top: '60%'}}></div>
                      <div className="scatter-point" style={{left: '50%', top: '40%'}}></div>
                      <div className="scatter-point" style={{left: '70%', top: '25%'}}></div>
                      <div className="scatter-point" style={{left: '45%', top: '50%'}}></div>
                      <div className="scatter-point" style={{left: '60%', top: '35%'}}></div>
                    </div>
                    <div className="graph-footer">
                      <span className="ev-fs-11 ev-reg-p-blue">Cost-effectiveness</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div >
          <div className="col-lg-5 col-md-5 d-flex">
                  <div className="ev-plans-image-wrap">
                    <img 
                      src="/media/img1.jpg" 
                      alt="Evaior Platform" 
                      className="w-100"
                    />
                    <div className="ev-plans-caption">
                      <h4 className="ev-bold-med mb-3">Agentic Intelligence.</h4>
                      <p className="ev-reg">Distribute intelligence generation across multiple autonomous agents. Each tackles specific tasks.  </p>
                    </div>
                  </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HomeGenBI;